module.exports = __webpack_public_path__ + "static/img/empty.981c4740.png";